
import React from 'react';
import Layout from '@/components/layout/Layout';
import SubscriptionPlans from '@/components/subscription/SubscriptionPlans';
import { useLanguage } from '@/context/language-context';
import { ShieldCheck, Image, MessageSquare } from 'lucide-react';

const Subscription = () => {
  const { t } = useLanguage();
  
  return (
    <Layout>
      <div className="py-12 px-4 bg-muted/30">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">{t('subscription.title')}</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              {t('subscription.subtitle')}
            </p>
          </div>
          
          <SubscriptionPlans />
          
          <div className="mt-16 max-w-3xl mx-auto text-center">
            <h2 className="text-2xl font-semibold mb-4">{t('subscription.why_subscribe')}</h2>
            <p className="text-muted-foreground mb-6">
              {t('subscription.why_description')}
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="p-6 rounded-lg bg-card shadow">
                <h3 className="font-semibold text-lg mb-2">{t('subscription.privacy_title')}</h3>
                <p className="text-muted-foreground">
                  {t('subscription.privacy_description')}
                </p>
              </div>
              <div className="p-6 rounded-lg bg-card shadow">
                <h3 className="font-semibold text-lg mb-2">{t('subscription.content_title')}</h3>
                <p className="text-muted-foreground">
                  {t('subscription.content_description')}
                </p>
              </div>
              <div className="p-6 rounded-lg bg-card shadow">
                <h3 className="font-semibold text-lg mb-2">{t('subscription.support_title')}</h3>
                <p className="text-muted-foreground">
                  {t('subscription.support_description')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Subscription;
